import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VplaybookLetDirective } from '../../directives/vplaybook-let/vplaybook-let.directive';

@NgModule({
  exports: [
    VplaybookLetDirective
  ],
  declarations: [
    VplaybookLetDirective
  ],
  imports: [
    CommonModule
  ]
})
export class VplaybookLetModuleModule { }
